import Vue from 'vue';
import Router from 'vue-router';
import beforeEach from './beforeEach';
import afterEach from './afterEach';
import routes from './routes';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: routes,
});

/**
* Before a route is resolved we check for
* the token if the route is marked as
* requireAuth.
*/
router.beforeEach(beforeEach);

router.afterEach(afterEach);

export default router;




// WEBPACK FOOTER //
// ./src/router/index.js